var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.attributes.activityId
    ? _c(
        "div",
        [
          !_vm.store.loading && _vm.activity.length
            ? _c("i", { staticClass: "fa fa-asterisk" })
            : _c("i", {
                staticClass: "fa fa-check",
                staticStyle: { color: "var(--green)" }
              }),
          _vm._v("\n  " + _vm._s(_vm.$t("kanbanCardActivity")) + "\n  "),
          _vm.isBoardNotInSelectedAccount
            ? _c("span", { staticClass: "small text-muted" }, [
                _vm._v(
                  "\n    (" +
                    _vm._s(_vm.$t("workflow.card.activityInDifferentAccount")) +
                    ")\n  "
                )
              ])
            : [
                _vm.store.loading
                  ? _c("Spinner", { attrs: { small: true } })
                  : _vm.activity.length
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "quick/activity?Act=" + _vm.attributes.activityId,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.activity))]
                    )
                  : _c("span", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.$t("workflow.card.activityClosed")) +
                          ")"
                      )
                    ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-edit c-pointer",
                  on: {
                    click: function($event) {
                      return _vm.$emit("open-system-attributes")
                    }
                  }
                })
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }